"use client"

export default function ColorparkEmbed() {
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
   <div className="w-full" style={{ aspectRatio: "9 / 16", maxHeight: '800px' }}>
  <iframe
    src="https://golf.colorpark.cn/#/pages/golf/index?machine_id=11224028"
    width="100%"
    height="100%"
    style={{ border: "none" }}
    title="Colorpark Golf Ball Designer"
  />
</div>
</div>

  );
}
